import CustomerCart from "components/CustomerCart";
import CustomerInfo from "components/CustomerInfo";
import CustomerOrder from "components/CustomerOrder";
import React from "react";

const StepContent = ({ activeStep, handleNext }) => {
  switch (activeStep) {
    case 0:
      return <CustomerCart />;
    case 1:
      return <CustomerInfo handleNext={handleNext} />;
    case 2:
      return <CustomerOrder />;
    default:
      return null;
  }
};

export default StepContent;
